import { __assign } from 'tslib';
import { baseTheme } from './defaultToolkitTheme.js';

var vmTheme = __assign(__assign({}, baseTheme), {
  name: "vinomofo",
  colors: __assign(__assign({}, baseTheme.colors), {
    mofoBrand: baseTheme.colors.mofoGreen,
    mofoPrimary: baseTheme.colors.mofoGreen,
    mofoSecondary: baseTheme.colors.vader
  })
});

export { vmTheme };
//# sourceMappingURL=vmTheme.js.map
